export const EMAIL_ICON = `
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M36.9531 15.125C36.9531 12.9418 35.1833 11.1719 33 11.1719H11C8.81675 11.1719 7.04688 12.9417 7.04688 15.125V28.875C7.04688 31.0583 8.81675 32.8281 11 32.8281H33C35.1833 32.8281 36.9531 31.0583 36.9531 28.875V15.125ZM40.0469 28.875C40.0469 32.7669 36.8919 35.9219 33 35.9219H11C7.10812 35.9219 3.95313 32.7669 3.95312 28.875V15.125C3.95312 11.2331 7.10812 8.07813 11 8.07812H33C36.8919 8.07813 40.0469 11.2331 40.0469 15.125V28.875Z"
      fill="currentColor"
    />

    <path
      d="M30.8576 17.2197C31.5993 16.7959 32.5439 17.0534 32.9678 17.7951C33.3916 18.5368 33.1341 19.4814 32.3924 19.9053L23.7906 24.8205C22.6809 25.4546 21.3191 25.4546 20.2094 24.8205L11.6076 19.9053C10.8659 19.4814 10.6084 18.5368 11.0322 17.7951C11.4561 17.0534 12.4007 16.7959 13.1424 17.2197L21.7442 22.1349C21.9027 22.2254 22.0973 22.2254 22.2558 22.1349L30.8576 17.2197Z"
      fill="currentColor"
    />
  </svg>
`;